import { Observable } from 'rxjs';
import { TreeNode } from 'primeng/api';

export enum IncludeOrExclude {
    includeAll = 'includeAll',
    include = 'include',
    exclude = 'exclude'
}

/**
 * This interface defines the functions needed to implement the DataSelectDialogComponent
 */

export interface DataSelectDialogServiceInterface {

    /**
     * Gets an observable to provide the data
     */
    getListItems(): Observable<TreeNode[]>;

    /**
     * Applies changes in selected list items
     */
    applySelectedListItems(selectedItems: TreeNode[], filterChildren?: boolean): void;

    /**
     * Getter for selected list items
     */
    getSelectedListItems(): Observable<TreeNode[]>;

    /**
     * Handles an list item check box event
     *
     * @param item item selected
     */
    itemSelected(item: TreeNode): void;

    /**
     * Handles node expanded
     *
     * @param item node expanded
     */
    nodeExpanded(item: TreeNode, setItemValue?: boolean): void;

    /**
     * Handles node collapsed
     *
     * @param item node collapsed
     */
    nodeCollapsed(item: TreeNode): void;

    /**
     * Handles a list item being removed from selected list
     * @param index position of item
     */
    itemRemoved(item: TreeNode, removeChildren?: boolean): void;

    /**
     * Handles deleting an item from the displayed selected items list
     */
    displayItemDeleted(item: TreeNode, removeChildren?: boolean): void;

    /**
     * Handles selection change event
     *
     * @param selectedItems the items selected
     */
    selectionChange(selectedItems: TreeNode[], listItems: TreeNode[], filterChildren?: boolean);

    /**
     * Returns an observable providing the different types of items that can be selected
     */
    getSelectedItemTypes(): Observable<Map<any, string>>;

    /**
     * Returns an observalbe providing the selected to items to display on
     * the right side panel of the component.
     */
    getSelectedItemsToDisplay(): Observable<TreeNode[]>;

    /**
     * Returns the new values selected, or the original values if no changes or cancel.
     */
    getSelectedItems(): any;

    /**
     * Filters all items by matching query string, hiding all non-matching items
     */
    filterItems(query: string): Observable<TreeNode[]>;

    /**
     * Reset selected items
     */
    reset(): void;
}
